export const dataTypes = [
    {label: 'Virus'},
    {label: 'Bacteria'},
    {label: 'Fungi'}
]